import React, {useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './ProgramManagement.module.css';
import { useSelector, useDispatch } from 'react-redux';
import { setQuestionnaire, removeQuestionnaire } from './AddProgramSlice';
import ManagementDropdownCard from '../../components/ManagementDropdownCard';
import MultiSelectDropdown from '../../components/MultiSelectDropdown';
import { getInitialStartTime, initSelectedQuestionnaires } from '../../utils/programUtils';

const QuestionnaireSetup = ({errors}) => {
    const {groupId} = useSelector((state)=>state.addProgram.program);
    const allQuestionnaires = useSelector((state)=>state.programTemplateLists.questionnaires);
    const filteredQuestionnaires = allQuestionnaires.filter((questionnaire)=>questionnaire.groupId === groupId);
    const dispatch = useDispatch();
    const programQuestionnaires = useSelector((state)=>state.addProgram.questionnaires);
    const [selectedQuestionnaires, setSelectedQuestionnaires] = useState(initSelectedQuestionnaires(programQuestionnaires, allQuestionnaires));
    
    const checkSelectedItem = (id) => {
        let qInList = false;
        selectedQuestionnaires.forEach((item)=>{
            if (item.questionnaireId===id){
                qInList=true;
            } 
        });
        return qInList;
    };

    const handleQuestionnaireChange = (q) => {
        let qInList = false;
        selectedQuestionnaires.forEach((item)=>{
            if (item.questionnaireId===q.questionnaireId){
                qInList = true;
            } 
        });
        if (qInList){
            setSelectedQuestionnaires(selectedQuestionnaires.filter(item => item.questionnaireId !== q.questionnaireId));
            dispatch(removeQuestionnaire(q.questionnaireId))
        } else {
            setSelectedQuestionnaires([q, ...selectedQuestionnaires]);
            let id = q.questionnaireId;
            let questionnaireName = q.name;
            dispatch(setQuestionnaire(
                {
                    id, 
                    questionnaireName,
                    startTime: getInitialStartTime(),
                    frequency: 1,
                    interval: "Day"
                }
            ))
        }
    };

    const removeQuestionnaireCard = (id) => {
        setSelectedQuestionnaires(selectedQuestionnaires.filter(item => item.questionnaireId !== id));
        dispatch(removeQuestionnaire(id));
    };

    return (
        <div style={{display:"flex", flexDirection:"column", gap:"10px", paddingBottom:"10px"}}>
            <MultiSelectDropdown 
                options={filteredQuestionnaires}
                label='name'
                checkedKey='questionnaireId'
                checkSelectedItem={checkSelectedItem}
                handleChange={handleQuestionnaireChange}
                selectedItems={selectedQuestionnaires}
                name='Questionnaires'
            />
            {errors.showing && 
                <div className={styles.ValidationMessageContainer}>
                    <FontAwesomeIcon icon="fa-solid fa-triangle-exclamation" size="xs" style={{color:"red"}}/>
                    <span 
                        className={styles.ValidationMessage}
                    >
                        {errors.message}
                    </span>
                </div>
            }
            <div style={{display:"flex", flexDirection:"column", gap:"10px"}}>
                {selectedQuestionnaires.map((q, index) => (
                    <div key={q.questionnaireId}>
                        <ManagementDropdownCard 
                            open={index!==0 ? false : true} 
                            cardInfo={{title:q.name, id:q.questionnaireId, type:"Questionnaire"}}
                            removeHandler={removeQuestionnaireCard}
                            updateHandler={setQuestionnaire}
                            dataList={programQuestionnaires}
                            errorShowing={errors.showing}
                        />
                    </div>
                ))}
            </div>
        </div>
    )
}

export default QuestionnaireSetup;